import {
  Search,
  Plus,
  RotateCcw,
  Building2,
} from "lucide-react";

export default function CustomerFilter({
  search = "",
  setSearch,
  branch = "",
  setBranch,
  onReset,
  onAddCustomer,
}) {
  return (
    <div className="w-full rounded-3xl border border-slate-200 bg-white p-6 shadow-sm">

      {/* Header */}
      <div className="flex flex-col gap-4 lg:flex-row lg:items-start lg:justify-between">

        <div>
          <h2 className="text-2xl font-bold text-slate-900">
            Customer Filters
          </h2>

          <p className="mt-1 text-sm text-slate-500">
            Search, filter and manage customer records.
          </p>
        </div>

        <button
          type="button"
          onClick={() => onAddCustomer?.()}
          className="inline-flex h-12 items-center justify-center gap-2 rounded-2xl bg-slate-950 px-6 font-medium text-white transition-all duration-300 hover:bg-slate-900 hover:-translate-y-0.5 active:scale-95"
        >
          <Plus size={18} />
          Add Customer
        </button>

      </div>

      {/* Filters */}
      <div className="mt-6 grid grid-cols-1 gap-4 lg:grid-cols-12">

        {/* Search */}
        <div className="relative lg:col-span-6">

          <Search
  size={20}
  aria-hidden="true"
  className="absolute left-4 top-1/2 -translate-y-1/2 text-slate-400"
/>

          <input
  type="text"
  value={search}
  onChange={(e) => setSearch?.(e.target.value)}
  autoComplete="off"
  spellCheck={false}
  maxLength={100}
  placeholder="Search by customer name, phone or email..."
            className="h-12 w-full rounded-2xl border border-slate-200 bg-white pl-12 pr-4 text-sm outline-none transition-all focus:border-blue-500 focus:ring-4 focus:ring-blue-100"
          />

        </div>

        {/* Branch */}
        <div className="relative lg:col-span-3">

          <Building2
  size={18}
  aria-hidden="true"
  className="absolute left-4 top-1/2 -translate-y-1/2 text-slate-400"
/>

          <select
  name="branch"
  value={branch}
  onChange={(e) => setBranch?.(e.target.value)}
            className="h-12 w-full appearance-none rounded-2xl border border-slate-200 bg-white pl-12 pr-4 text-sm outline-none transition-all focus:border-blue-500 focus:ring-4 focus:ring-blue-100"
          >
            <option value="">All Branches</option>
            <option value="Z.A. Optical Johripur">Z.A. Optical Johripur</option>
            <option value="Z.A. Optical Jhilmil">Z.A. Optical Jhilmil</option>
          </select>

        </div>

        {/* Reset */}
        <div className="lg:col-span-3">

          <button
            type="button"
           onClick={() => onReset?.()}
            className="flex h-12 w-full items-center justify-center gap-2 rounded-2xl border border-slate-200 bg-white text-slate-700 transition-all duration-300 hover:border-blue-300 hover:bg-slate-50"
          >
           <RotateCcw
  size={18}
  aria-hidden="true"
/>
            Reset
          </button>

        </div>

      </div>

    </div>
  );
}